import { useDisplayDate } from "./useDisplayDate"

export function useReadableDate(day: string): string {
  const displayDate = useDisplayDate()
  return displayDate(day)
}
